export function haversineDistance(loc1, loc2, unit = 'km') {
  const toRad = (value) => (value * Math.PI) / 180;
  const earthRadiusKm = 6371;

  const lat1 = Number(loc1.lat);
  const lon1 = Number(loc1.lon);
  const lat2 = Number(loc2.lat);
  const lon2 = Number(loc2.lon);

  if (
    !Number.isFinite(lat1) ||
    !Number.isFinite(lon1) ||
    !Number.isFinite(lat2) ||
    !Number.isFinite(lon2)
  ) {
    return null;
  }

  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);

  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) *
      Math.cos(toRad(lat2)) *
      Math.sin(dLon / 2) ** 2;

  const c =
    2 *
    Math.atan2(
      Math.sqrt(a),
      Math.sqrt(1 - a)
    );

  const distanceKm = earthRadiusKm * c;

  return unit === 'miles'
    ? distanceKm * 0.621371
    : distanceKm;
}